// Dialogs.tsx
import React from 'react';
import Dialog from '@components/Atoms/Dialog';
import Typography from '@components/Atoms/Typography';

const ErrorDialog = ({ open, onClose, taskId }) => (
  <Dialog
    title="Ooops!!"
    actions={[
      {
        label: 'Close',
        onClick: onClose,
        buttonProps: {
          variant: 'contained',
          color: 'primary',
        },
      },
    ]}
    open={open}
    onClose={onClose}
    data-testid="qgs-error-dialog"
  >
    <Typography variant="body1" sx={{ textAlign: 'start' }}>
      Something went wrong. Please try again.
      <br />
      If the issue persists, please contact support with the following:
      <br />
      <br />
      Issue ID: {taskId || 'N/A'}
    </Typography>
  </Dialog>
);

const SubmissionDialog = ({ open, onClose, submissionList }) => (
  <Dialog
    title="Question Submitted!"
    subtitle="Your generated and custom questions have been saved in our practice itembank"
    actions={[
      {
        label: 'Close',
        onClick: onClose,
        buttonProps: {
          variant: 'contained',
          color: 'primary',
        },
      },
    ]}
    open={open}
    fullWidth
    onClose={onClose}
    data-testid="qgs-submission-dialog"
  >
    <Typography variant="body1" sx={{ textAlign: 'start' }}>
      The generated and custom questions have been submitted under the selected options:
    </Typography>
    {submissionList}
  </Dialog>
);

const CopyrightDialog = ({
  open,
  onAccept,
  onDecline,
}: {
  open: boolean;
  onAccept: () => void;
  onDecline: () => void;
}) => (
  <Dialog
    title="Co-Author Copyright Disclaimer"
    actions={[
      {
        label: 'I Understand',
        onClick: onAccept,
        buttonProps: {
          variant: 'contained',
          color: 'primary',
        },
      },
      {
        label: 'Decline and Exit',
        onClick: onDecline,
        buttonProps: {
          variant: 'contained',
          color: 'error',
        },
      },
    ]}
    open={open}
    fullWidth
    data-testid="qgs-copyright-dialog"
    showCloseIcon={false}
  >
    <Typography variant="body1">
      Users are responsible for ensuring compliance with copyright laws in accordance with
      the Digital Millennium Copyright Act (DMCA) when interacting with editable content
      within the ChalkTalk platform, including passages, questions, or any other
      materials.
    </Typography>
    <Typography variant="body1" sx={{ mt: '1rem' }}>
      ChalkTalk may summarize the requested text if it believes the underlying content to
      be protected (e.g. authored within 100 years and not licensed under Creative
      Commons).
    </Typography>
  </Dialog>
);

export { ErrorDialog, SubmissionDialog, CopyrightDialog };
